import axios from 'axios'

export function loginHttp({userName, password, checkCode, checkCodeKey}) {
  return axios({
    url: '/auth/login/login',
    method: 'post',
    headers: {
      isToken:false,
      'Authorization': 'Basic eGluaHVhbmV0TXNDaGF5YW86eGluaHVhbmV0TXNDaGF5YW8='
    },
    data: {
      userName,
      password,
      checkCode,
      checkCodeKey
    }
  })
}

export function logoutHttp() {
  return axios({
    url: '/auth/login/logout',
    method: 'post'
  })
}

export function getCode() {
  return axios({
    url: '/auth/login/captcha',
    method: 'post',
    headers: {
      isToken:false,
      'Authorization': 'Basic eGluaHVhbmV0TXNDaGF5YW86eGluaHVhbmV0TXNDaGF5YW8='
    },
    data: {}
  })
}

export function refreshToken(refreshToken) {
  const grant_type = 'refresh_token'
  return axios({
    url: '/auth/login/refresh',
    headers: {
      'isToken': false,
      'Authorization': 'Basic eGluaHVhbmV0TXNDaGF5YW86eGluaHVhbmV0TXNDaGF5YW8=',
    },
    method: 'post',
    data: { refreshToken}
  })
}

export const getUserInfo = () => {
  return axios({
    url: '/sys/user/getCurrentUserInfo',
    method: 'post'
  })
}

export const passwordModify = (obj) => {
  return axios({
    url: '/sys/user/updatePasswordBySelf',
    method: 'post',
    data: obj
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js